module.exports = __webpack_public_path__ + "img/ys-one-grid-select.6da87f99.png";